import React, { createContext, useContext, useState, useEffect } from 'react';
import { translations, languages } from '../locales';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    try {
      const saved = localStorage.getItem('tradeflow_language');
      return translations[saved] ? saved : 'ru';
    } catch (error) {
      return 'ru';
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem('tradeflow_language', language);
    } catch (error) {
      // Some browser privacy modes can block localStorage.
    }
  }, [language]);

  const resolve = (source, key) => {
    return key.split('.').reduce((value, part) => {
      if (value && Object.prototype.hasOwnProperty.call(value, part)) {
        return value[part];
      }
      return undefined;
    }, source);
  };

  const t = (key) => {
    const activeValue = resolve(translations[language], key) ?? translations[language]?.[key];
    const fallbackValue = resolve(translations.en, key) ?? translations.en?.[key];
    return activeValue ?? fallbackValue ?? key;
  };

  const changeLanguage = (lang) => {
    if (translations[lang]) {
      setLanguage(lang);
    }
  };

  return (
    <LanguageContext.Provider value={{ language, t, changeLanguage, languages }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};
